import { useNavigate } from "react-router-dom";

const DOT_COLORS = {
  amber: "var(--status-warning)",
  green: "var(--status-success)",
  red:   "var(--status-danger)",
  blue:  "var(--brand-primary)",
};

const SkeletonRow = () => (
  <div className="activity-item">
    <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#f0f4fa", marginTop: 5, flexShrink: 0 }} />
    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 5 }}>
      <div style={{ height: 13, width: "70%", borderRadius: 4, background: "#f0f4fa" }} />
      <div style={{ height: 11, width: "35%", borderRadius: 4, background: "#f0f4fa" }} />
    </div>
  </div>
);

export default function ActivityFeed({ loading, items = [] }) {
  const navigate = useNavigate();

  return (
    <div className="ph-card">
      <div className="ph-card-header">
        <div className="ph-card-title">
          <i className="pi pi-history" />
          Recent Activity
        </div>
      </div>

      {loading ? (
        <><SkeletonRow /><SkeletonRow /><SkeletonRow /><SkeletonRow /></>
      ) : items.length === 0 ? (
        <div style={{
          padding: "28px 20px", textAlign: "center",
          color: "var(--text-muted)", fontSize: 13,
        }}>
          <i className="pi pi-inbox" style={{ fontSize: 24, display: "block", marginBottom: 8 }} />
          No recent activity
        </div>
      ) : (
        <>
          {items.map((item) => (
            <div key={item.id} className="activity-item">
              <div
                className="activity-dot"
                style={{ background: DOT_COLORS[item.type] ?? DOT_COLORS.blue }}
              />
              <div className="activity-content">
                <div className="activity-title">{item.title}</div>
                <div className="activity-time">{item.time}</div>
              </div>
            </div>
          ))}

          {/* View all — navigates to notifications page */}
          <div
            onClick={() => navigate("/notifications")}
            style={{
              padding: "11px 20px",
              borderTop: "1px solid var(--border-light)",
              display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
              cursor: "pointer", fontSize: 12.5, fontWeight: 500,
              color: "var(--brand-primary)",
              transition: "background 0.15s",
            }}
            onMouseEnter={e => e.currentTarget.style.background = "var(--brand-light)"}
            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
          >
            View all activity
            <i className="pi pi-arrow-right" style={{ fontSize: 11 }} />
          </div>
        </>
      )}
    </div>
  );
}